import React, { Component } from 'react'
import { connect } from 'react-redux'

import { push } from 'connected-react-router'

import PublishModal from './publish-modal'
import PageWrapper from '../../components/PageWrapper'
import LicensingErrorAlert from './error-alert'
import NewLicenseConfigHeader from './new-license-config-header'

import 'react-datepicker/dist/react-datepicker.css'

import './styles.css'
import axios from 'axios'


class EditLicense extends Component {
    constructor(props) {
        super(props)

        console.log('EDIT ', this.props.location.state.license)

        this.state = {
            license: this.props.location.state.license
        }
    }

    onCancel = () => this.props.goBack()

    onPublish = license => {
        console.log('on publish ', license)
        axios.patch('/license', license).then(response => {
            this.props.goBack()
        })
    }

    onFailPublish = error => {
        this.setState({ error })
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    {this.state.error && <LicensingErrorAlert error={this.state.error} />}
                    <NewLicenseConfigHeader license={this.state.license} editMode={true} onCancel={this.onCancel} onNext={this.onPublish} />
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/licenses')
    }
)(EditLicense)
